import React from "react";

export default function Footer() {
  return (
    <div className="Footer">
      <p className="FooterP" style={{ paddingTop: "25px" }}>
        Designed and developed By Mohamed Salah
      </p>
      <p className="FooterP">Inspired by Marvel</p>
    </div>
  );
}
